/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

import { getAiSearchResults, getChirpAiSearchResults, getReportTemplateSearchResults, setReportsFilters } from '../actions/reportsActions';
import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import ReportsListingPage from './ReportsListingPage';
import { useDispatch, useSelector } from 'react-redux';
import getInitialFilters from '../lib/getInitialFilters';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { selectGenerativeAIEnabled } from '../selectors/aiSettingsSelector';
import { selectReportCollectionTemplatesByKey } from '../redux/reportCollectionTemplates';
import { getIsUngatedToUseChirpEndpoints } from '../selectors/gatesSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportsContainer = props => {
  const {
    match: {
      params: {
        templateId
      }
    }
  } = props;
  const dispatch = useDispatch();
  const isUngatedToUseChirpEndpoints = useSelector(getIsUngatedToUseChirpEndpoints);
  const isGenerativeAiEnabled = useSelector(selectGenerativeAIEnabled);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const showMyReports = !templateId;
  const initialReportFilters = useMemo(() => {
    var _getInitialFilters;
    return (_getInitialFilters = getInitialFilters()) === null || _getInitialFilters === void 0 ? void 0 : _getInitialFilters.reportFilters;
  }, []);
  const initialSearch = initialReportFilters === null || initialReportFilters === void 0 ? void 0 : initialReportFilters.filterSearch;
  useEffect(() => {
    if (showMyReports) {
      dispatch(setReportsFilters(initialReportFilters));
    }
  }, [dispatch, initialReportFilters, showMyReports]);
  useEffect(() => {
    if (initialSearch) {
      dispatch(getReportTemplateSearchResults());
    }
  }, [dispatch, initialSearch]);
  useEffect(() => {
    if (initialSearch && isGenerativeAiEnabled && (templatesByKey === null || templatesByKey === void 0 ? void 0 : templatesByKey.size) > 0) {
      if (isUngatedToUseChirpEndpoints) {
        dispatch(getChirpAiSearchResults(initialSearch, templatesByKey));
      } else {
        dispatch(getAiSearchResults(initialSearch, templatesByKey));
      }
    }
  }, [dispatch, initialSearch, isGenerativeAiEnabled, templatesByKey, isUngatedToUseChirpEndpoints]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "app",
    children: [/*#__PURE__*/_jsx(ReportsListingPage, {}), /*#__PURE__*/_jsx(NotificationList, {})]
  });
};
ReportsContainer.propTypes = {
  actions: PropTypes.shape({
    getReportCounts: PropTypes.func.isRequired,
    getOwners: PropTypes.func.isRequired,
    fetchDashboardWidgetCounts: PropTypes.func.isRequired,
    setReportsFilters: PropTypes.func.isRequired,
    getReport: PropTypes.func.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  match: PropTypes.shape({
    params: PropTypes.object
  }).isRequired
};
export default withRouter(ReportsContainer);